import {
  // eslint-disable-next-line no-restricted-imports
  Typography as FitifyUiTypography,
  typographyStyles,
} from 'fitify-ui/src/typography/generated/Typography'
import type { TypographyVariants } from 'fitify-ui/src/typography/generated/Typography.Types'
import { css, styled } from 'styled-components'

import { phone } from '../../theme/breakpoints'

export const Typography = styled(FitifyUiTypography)<{
  $variantPhone?: TypographyVariants
}>`
  ${({ $variantPhone }) => {
    if ($variantPhone) {
      return css`
        ${phone(css`
          ${typographyStyles($variantPhone)};
        `)};
      `
    }
    return undefined
  }}
`
